__turbopack_context__.v({
  "carouselDefault": "Carousel-module-scss-module__64_yFa__carouselDefault",
  "carouselSlide": "Carousel-module-scss-module__64_yFa__carouselSlide",
});
